module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showAddVoucherArea) ? _c('div', {
    staticClass: "app bg-gray"
  }, [_c('scroll', {
    staticStyle: {
      "background": "#f0f1f5"
    },
    on: {
      "refresh": _vm.loadVouchers
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddVoucherArea),
      expression: "showAddVoucherArea"
    }],
    staticClass: "flex-row flex-align-center add-voucher-area",
    on: {
      "click": _vm.addVoucher
    }
  }, [_c('div', {
    staticClass: "add-voucher-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-1 flex-width"
  }, [_vm._v("\n        暂无就诊凭证，请"), _c('span', {
    staticClass: "f-strong"
  }, [_vm._v("先绑定就诊凭证")])])])])], 1) : _c('div', {
    staticClass: "app bg-gray",
    attrs: {
      "id": "register-registConfirm"
    }
  }, [_c('div', {
    staticClass: "bg-white",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "padding": "0.3rem"
    }
  }, [_c('span', [_vm._v("选择就诊凭证查看居民健康档案")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddVoucherBtn),
      expression: "showAddVoucherBtn"
    }],
    staticClass: "btn-ugly",
    on: {
      "click": _vm.addVoucher
    }
  }, [_vm._v("\n      +添加家庭成员\n    ")])]), _vm._v(" "), _c('scroll', {
    staticClass: "to-bottom-btn",
    staticStyle: {
      "top": "1.6rem",
      "background": "#fff"
    },
    on: {
      "refresh": _vm.loadVouchers
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddVoucherArea),
      expression: "showAddVoucherArea"
    }],
    staticClass: "flex-row flex-align-center add-voucher-area",
    on: {
      "click": _vm.addVoucher
    }
  }, [_c('div', {
    staticClass: "add-voucher-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-1 flex-width"
  }, [_vm._v("\n        暂无就诊凭证，请"), _c('span', {
    staticClass: "f-strong"
  }, [_vm._v("先绑定就诊凭证")])])]), _vm._v(" "), _vm._l((_vm.vouchers), function(voucher, index) {
    return _c('voucher-item-small', {
      key: index,
      class: _vm.selectedIndex == index ? 'selected' : 'disabled',
      attrs: {
        "voucher": voucher,
        "index": index
      },
      on: {
        "selected": _vm.selectVoucher
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "register-des"
  }, [_c('h5', {
    staticClass: "reminder"
  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("1.您可通过添加家庭成员查询家人健康档案。")])])], 2), _vm._v(" "), _c('footer', [_c('button', {
    staticClass: "btn-complete",
    staticStyle: {
      "border-radius": "0"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goSendVerifyCodePage
    }
  }, [_vm._v("\n      确认\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f23ab6e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/residentHealthRecord/VoucherSelect.vue
// module id = 848
// module chunks = 0